/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-20 17:59:12
 * @LastEditTime: 2019-08-26 11:18:40
 * @LastEditors: Please set LastEditors
 */
export class GeometryExtentUtility {
    /**
     * 该方法有错误
     * @param {*} points  点集格式[[x y],[x y]]
     */
    static GetExtent(points) {
        let envelope = new Array();

        let xMax = -1;
        let xMin = -1;
        let yMax = -1;
        let yMin = -1;
        let tempPnt = null;
        for (let pntIndex = 0; pntIndex < points.length; pntIndex++) {
            tempPnt = points[pntIndex];

            if (pntIndex === 0) {
                xMin = tempPnt[0];
                xMax = tempPnt[0];
                yMin = tempPnt[1];
                yMax = tempPnt[1];
            }
            else {
                if (tempPnt[0] < xMin) {
                    xMin = tempPnt[0];
                }
                if (tempPnt[1] < yMin) {
                    yMin = tempPnt[1];
                }
                if (tempPnt[0] > xMax) {
                    xMax = tempPnt[0];
                }
                if (tempPnt[1] > yMax) {
                    yMax = tempPnt[1];
                }
            }
        }

        envelope.push(xMin);
        envelope.push(yMin);
        envelope.push(xMax);
        envelope.push(yMax);

        return envelope;
    }

    /**
     * 获取所有点的外接矩形 
     * @param {*} points  点集格式[x,y字符串,x,y字符串]
     */
    static GetExtentEx(points) {
        let envelope =new Array();

        let xMax = -1;
        let xMin = -1;
        let yMax = -1;
        let yMin = -1;
        let tempPntString=null;
        let tempPntStringSplitArray=null;
        let tempPntX=null;
        let tempPntY=null;
        
        for (let pntIndex = 0; pntIndex < points.length; pntIndex++) {
            tempPntString = points[pntIndex];
            if(!tempPntString)continue;

            
            tempPntStringSplitArray = tempPntString.split(",");
            if(!tempPntStringSplitArray || tempPntStringSplitArray.length !=2)continue;
            tempPntX= parseFloat(tempPntStringSplitArray[0]) ;
            tempPntY=parseFloat(tempPntStringSplitArray[1]);
            
            if (pntIndex === 0) {
                xMin = tempPntX;
                xMax = tempPntX;
                yMin = tempPntY;
                yMax =tempPntY;
            }
            else {
                if (tempPntX < xMin) {
                    xMin = tempPntX;
                }
                if (tempPntY < yMin) {
                    yMin = tempPntY;
                }
                if (tempPntX > xMax) {
                    xMax = tempPntX;
                }
                if (tempPntY > yMax) {
                    yMax = tempPntY;
                }
            }
        }

        envelope.push(xMin);
        envelope.push(yMin);
        envelope.push(xMax);
        envelope.push(yMax);

        return envelope;
    }

    /**
     * 
     * @param {*} points  点集格式[x,y,x,y]
     */
    static getCenterPointEx(points)
    {   
        let centerPnt=new Array();
        let extent = GeometryExtentUtility.GetExtentEx(points);
        let centerX=(extent[0] + extent[2])/2.0;
        let centerY=(extent[1] +extent[3])/2.0;
        centerPnt.push(centerX);
        centerPnt.push(centerY);
        return centerPnt;
    }

    static isGeoExtent(extent)
    {   
        let isGeo=false;

        let minX=extent[0];
        let minY=extent[1];
        let maxX=extent[2];
        let maxY=extent[3];

        

        if(Math.abs(minX)<=180
        && Math.abs(maxX)<=180
        && Math.abs(minY)<=90
        && Math.abs(maxY)<=90)
        {   
            isGeo=true;
        }   

        return isGeo;
    }

    /**
     * 扩展范围
     * @param {*} oriExtent 
     * @param {*} expandScale 
     */
    static expandExtent(oriExtent,expandScale)
    {   
        let expandEnvelope =null;//
        
        if(!oriExtent || !expandScale)return expandEnvelope;
        
        expandEnvelope=new Array();

        let minX=oriExtent[0];
        let minY=oriExtent[1];

        let oriCenterX=(oriExtent[0] + oriExtent[2])/2.0;
        let oriCenterY=(oriExtent[1] +oriExtent[3])/2.0;

        let halfXDistance=oriCenterX-minX;
        let halfYDistance=oriCenterY-minY;

        let expandMinX=oriCenterX-halfXDistance*expandScale;
        let expandMinY=oriCenterY-halfYDistance*expandScale;
        let expandMaxX=oriCenterX + halfXDistance*expandScale;
        let expandMaxY=oriCenterY + halfYDistance*expandScale;

        expandEnvelope.push(expandMinX);
        expandEnvelope.push(expandMinY);
        expandEnvelope.push(expandMaxX);
        expandEnvelope.push(expandMaxY);
        return expandEnvelope;
    }

    /**
     * 是否相交
     * @param {*} extent 
     * @param {*} compareExtent 
     */
    static isIntersect(originalEnv,compareEnv)
    {   
        let intersectStatus=false;

            let originalXMin = originalEnv[0];
            let originalXMax = originalEnv[2];
            let originalYMin = originalEnv[1];
            let originalYMax = originalEnv[3];

            let compareXMin = compareEnv[0];
            let compareXMax = compareEnv[2];
            let compareYMin = compareEnv[1];
            let compareYMax = compareEnv[3];

            let intersectXMin =Math.max(originalXMin, compareXMin);
            let intersectXMax = Math.min(originalXMax,compareXMax);
            let intersectYMin = Math.max(originalYMin,compareYMin);
            let intersectYMax = Math.min(originalYMax,compareYMax);
            
            //如果相交
            if (intersectXMax >= intersectXMin && intersectYMax >= intersectYMin)
            {
                intersectStatus=true;
            }
            else
            {
                intersectStatus=false;
            }
            
            return intersectStatus;
    }


}